// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"527":"40af29176ee4d5772fef","572":"05b8898abe1e1273f92a"}[chunkId] + ".css";
};